<template>
    <l-tile-layer v-if="this.dataLoaded" :url="this.$props.url" :attribution="attribution"></l-tile-layer>
    <l-polyline @click="showDetail" v-if="this.dataLoaded" :lat-lngs="polyline.latlngs" :color="polyline.color" :weight="this.weight"><l-tooltip v-if="this.$props.tooltips" :options="{permanent:true}">{{this.$props.leitungsObj.durchlaufmenge}}</l-tooltip></l-polyline>
    <span v-for="position in this.leitungsPositionen" :key="position.positionsID">
      <!--<l-marker v-if="position.nachfolger == null || position.vorgaenger == null" @click="markerClick" :lat-lng="[position.positionX,position.positionY]"></l-marker>-->
      <l-marker v-if="(this.$props.leitungenHinzufuegenBoolean || this.$props.leitungenEntfernenBoolean) && (position.nachfolger == null || position.vorgaenger == null)" :lat-lng="[position.position.x,position.position.y]" @click="markerClick($event,position)"></l-marker>
    </span>
</template>

<script>
import { LMarker, LTileLayer, LPolyline, LTooltip } from "@vue-leaflet/vue-leaflet";
import Swal from 'sweetalert2';

export default {
  name: "Leitung",
  components: {
    LTileLayer,
    LPolyline,
    LMarker,
    LTooltip
  },
  props: {
    leitungsObj: Object,
    url: String,
    leitungenController: Object,
    leitungenHinzufuegenBoolean: Boolean,
    leitungenEntfernenBoolean: Boolean,
    tooltips: Boolean,
    farbigeLeitungen: Boolean
  },
  data() {
    return {
      //url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      polyline: {
        latlngs: [],
        color: 'blue'
      },
      leitungsPositionen: [],
      weight: 5,
      dataLoaded: false,
    };
  },
  methods: {
    setWeightAndColor(){
      if(this.$props.leitungsObj.durchlaufmenge < 100){
        if(this.$props.farbigeLeitungen){
          this.polyline.color = 'red';
        } else{
          this.polyline.color = 'blue';
          this.weight = 4;
        }
      }
      if(this.$props.leitungsObj.durchlaufmenge >= 100 && this.$props.leitungsObj.durchlaufmenge < 125){
        if(this.$props.farbigeLeitungen){
          this.polyline.color = 'orange';
        } else{
          this.polyline.color = 'blue';
          this.weight = 5;
        }
      }
      if(this.$props.leitungsObj.durchlaufmenge >= 125 && this.$props.leitungsObj.durchlaufmenge < 150){
        if(this.$props.farbigeLeitungen){
          this.polyline.color = 'yellow';
        } else{
          this.polyline.color = 'blue';
          this.weight = 6;
        }
      }
      if(this.$props.leitungsObj.durchlaufmenge >= 150 && this.$props.leitungsObj.durchlaufmenge < 200){
        if(this.$props.farbigeLeitungen){
          this.polyline.color = 'green';
        } else{
          this.polyline.color = 'blue';
          this.weight = 7;
        }
      }
      if(this.$props.leitungsObj.durchlaufmenge >= 200){
        if(this.$props.farbigeLeitungen){
          this.polyline.color = 'blue';
        } else{
          this.polyline.color = 'blue';
          this.weight = 8;
        }
      }
    },
    showDetail(){
      Swal.fire({
        title: 'Durchmesser: ' + this.$props.leitungsObj.durchlaufmenge + ' mm',
      });
    },
    markerClick(event, position){
      console.log("Marker clicked at position:", position);
      if(this.$props.leitungenHinzufuegenBoolean){
        this.$emit('addLeitungsposition', {position: position, obj: this});
      }
      if(this.$props.leitungenEntfernenBoolean){
        this.$emit('removeLeitungsposition', {position: position, obj: this});
      }
    },
    refreshLeitungspositionen(){
      this.leitungsPositionen = this.$props.leitungenController.getAlleLeitungspositionenFromLeitungsID(this.$props.leitungsObj.leitungsID);
      this.polyline.latlngs = [];
      this.leitungsPositionen.forEach(pos => {
        this.polyline.latlngs.push([pos.position.x, pos.position.y]);
      });
    }
  },
  async created(){
    this.leitungsPositionen = this.$props.leitungenController.getAlleLeitungspositionenFromLeitungsID(this.$props.leitungsObj.leitungsID);
    this.dataLoaded = true;
    this.leitungsPositionen.forEach(pos => {
        this.polyline.latlngs.push([pos.position.x, pos.position.y]);
    });
    this.setWeightAndColor();
  }
};
</script>